import React from 'react';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {userActions} from '../user-manager';
import {Input} from '../form-component';

class LoginForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            submitted: false,
            errors: {}
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.updateElement = this.updateElement.bind(this);
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    mapErrors(violations) {
        let errors = {};

        for (let i = 0; i < violations.length; i++) {
            const violation = violations[i];

            if (!errors[violation.propertyPath]) {
                errors[violation.propertyPath] = [];
            }
            errors[violation.propertyPath].push(violation.message);
        }

        this.setState({errors: errors});
    }

    updateElement(name, value) {
        const state = {...this.state};


        if (!this.state.hasOwnProperty(name)) {
            return;
        }

        state[name] = value;
        state.errors[name] = [];
        this.setState(state);
    }

    handleSubmit(e) {
        e.preventDefault();

        let violations = [];

        if (this.state.username === '') {
            violations.push({propertyPath: 'username', message: 'L\'email est obligatoire.'});
        }

        if (this.state.password === '') {
            violations.push({propertyPath: 'password', message: 'Le mot de passe est obligatoire.'});
        }

        if (violations.length === 0) {
            this.setState({submitted: true});
            const {username, password} = this.state;
            const {dispatch} = this.props;
            if (username && password) {
                dispatch(userActions.login(username, password));
            }
        } else {
            this.mapErrors(violations);
        }
    }

    render() {
        window.location.hash = '#container';

        const {loggingIn} = this.props;
        const {username, password} = this.state;

        return (
            <div>
                <div id="fields">
                    {! loggingIn && <form onSubmit={this.handleSubmit} noValidate className="ajax-contact-form form-horizontal">
                        <div className="block1 clearfix">
                            <div className="block3">
                                <div className="control-group">
                                    <label className="control-label" htmlFor="email">Email</label>
                                    <div className="controls">
                                        <Input name="username" label="Email" type="email"
                                               value={username}
                                               placeholder="email@domain.fr"
                                               errors={this.state.errors.username} updateElement={this.updateElement}
                                               required="true"/>
                                    </div>
                                    <div className="control-group">
                                        <label className="control-label" htmlFor="password">Password</label>
                                        <div className="controls">
                                            <Input name="password" label="Mot de passe" type="password"
                                                   value={password}
                                                   placeholder="123456"
                                                   errors={this.state.errors.password}
                                                   updateElement={this.updateElement}
                                                   required="true"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="col-md-6">
                                <Link to="/password/get-new-password" className="btn btn-link btn-block">Mot de passe oublié</Link>
                            </div>
                            <div className="col-md-6">
                                <button type="submit" className="submit btn btn-info btn-block">Se connecter</button>
                            </div>
                        </div>


                    </form> }

                    {loggingIn && <div className="loading"><img src="/loading.gif" alt="loading"/></div>}
                </div>

            </div>
        );
    }
}

function mapStateToProps(state) {
    const {loggingIn, user} = state.authentication;
    return {
        loggingIn,
        user
    };
}

const connectedLoginForm = connect(mapStateToProps)(LoginForm);
export {connectedLoginForm as LoginForm};